import React, { memo, useCallback, useEffect, useRef, useState } from 'react';
import Captcha from 'react-captcha-code';
import PropTypes from 'prop-types';
import { Button, Input } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
import InfoBox from '../InfoBox';

const CaptchaCanvas = ({ t, handleMatching, charNum, ...rest }) => {
  const captchaRef = useRef();
  const [code, setCode] = useState('');
  const [captcha, setCaptcha] = useState('');

  const handleCodeChange = useCallback((e) => {
    setCode(e.target.value);
  }, []);

  const handleCaptchaChange = useCallback((e) => {
    setCaptcha(e);
  }, []);

  const handleClick = () => {
    captchaRef.current.refresh();
  };

  useEffect(() => {
    handleMatching((code === captcha));
  }, [captcha, code, handleCaptchaChange, handleCodeChange, handleMatching]);

  return (
    <div className={'flex-col place-items-start justify-items-auto'}>
      <div className="ant-col ant-form-item-label pb-0">
        <label title={t('captcha.label')}>{t('captcha.label')}</label>
      </div>
      <div className="mb-1 max-w-3/4">
        <InfoBox title={t('captcha.help')}/>
      </div>
      <div className={'flex place-items-start justify-items-auto h-full'}>
        <Captcha
          charNum={charNum}
          height={80}
          width={265}
          fontSize={50}
          {...rest}
          ref={captchaRef}
          onChange={(e) => handleCaptchaChange(e)}
        />
        <Button
          className={'mb-0 flex items-center justify-center w-full'}
          type={'primary'}
          size={'large'}
          icon={<ReloadOutlined/>}
          style={{
            height: 80,
            minWidth: 50,
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0
          }}
          onClick={handleClick}/>
      </div>
      <div className={'flex place-items-start justify-items-start'}>
        <Input
          className="w-full"
          style={{
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0,
          }}
          size={'large'}
          placeholder={t('captcha.placeholder')}
          onChange={(e) => handleCodeChange(e)}
          value={code}
        />
      </div>
    </div>
  );
};

CaptchaCanvas.propTypes = {
  t: PropTypes.func,
  charNum: PropTypes.number,
  handleMatching: PropTypes.func,
};

CaptchaCanvas.defaultProps = {
  charNum: 4,
  t: (v) => v,
  handleMatching: (a) => a
};

export default memo(CaptchaCanvas);

